import { apiFunction } from "../../apiCall/function"

export const getQuestion = async (data) => {

  return await apiFunction("question", "post", data, true, '')
}